import { feature as topoToGeo } from "topojson-client";

const convertTopoIfNeeded = (topologyObjectsName) => (json) => {
  return topologyObjectsName
    ? topoToGeo(json, json.objects[topologyObjectsName])
    : json;
};
const toJSON = (response) => response.json();
const fetchJson = (url) => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
  return (dispatch) => {
    dispatch({ type: "GEOJSON:REQUEST" });
    return fetchJson(url)
      .then(convertTopoIfNeeded(topologyObjectsName))
      .then((geojson) =>
        dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
      )
      .catch((error) => dispatch({ type: "GEOJSON:FAILURE", payload: error }));
  };
};

const sheetId = "1VneCw3eRAaAjZNEa80HxqlXUlWgM2Q_jJk4loe-XkvA"; // PRODUCTION SHEET

const sheetServer = "holy-sheet";
export const sheetIdToUrl = (id) =>
  `https://${sheetServer}.visualise.today/sheet/${id}`;

export const getRegionContent = () => {
  return (dispatch) => {
    return fetchJson(sheetIdToUrl(`${sheetId}?range=content!A1:C130`)).then(
      (content) => {
        content = content.reduce(
          (a, d) => ({
            ...a,
            [d.region]: {
              description: d.description,
              link: d.link,
            },
          }),
          {}
        );

        // store the regions info
        // none should be active
        // should be linked to activeFeature
        dispatch({
          type: "REGIONCONTENT:SET",
          payload: content,
        });

        dispatch({
          type: "ACTIVE_FEATURE:SET",
          payload: null,
        });
      }
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/data.js